module.exports = __webpack_public_path__ + "img/folha-moeda.d60c95ee.svg";